import VueRouter from "vue-router";
// import r from './router';
import dsdatavisual from './dsdatavisual';
import search from './search';
import xskdatavisual from "./xskdatavisual";
import tourism from './industry/tourism';
import mba from './industry/mba';
import logistics from './industry/logistics';


const routes = [
    { path: '/xskdatavisual.html',component: xskdatavisual},
    { path: '/dsdatavisual.html',component: dsdatavisual},
    { path: '/visual/ds.html',component: dsdatavisual},
    { path: '/visual/search.html',component: search},
    { path:'/visual/industry/tourism.html',component:tourism},
    { path:'/visual/industry/mba.html',component:mba},
    { path:'/visual/industry/logistics.html',component:logistics},
];
const router = new VueRouter({
    mode: "history", // History模式，可去掉路径访问中的"#"部分，不加此句代码是hash模式
    routes
});

export default router;
